export default __webpack_public_path__ + "static/media/about3.afc31e53.jpg";